import { UiDomUtils } from '@dreamcommerce/utilities';
import { v4 as uuidv4 } from 'uuid';

;
(function (undefined) {
    Shop.Modal.include({
        options: {
            autoShow: false, // TODO: not yet supported
            showMask: true,

            position: 'center',
            positionType: 'fixed',
            offset: 20,
            mobileBreakPoint: 600,

            header: null,
            content: null,
            footer: null,

            contentMaxHeight: null,
            contentMaxWidth: null,

            onPostShow: null
        },

        object: {
            container: null,
            header: null,
            body: null,
            footer: null,

            mask: null,

            position: {}
        },

        params: {
            width: 0,
            height: 0,
            leftPos: 0,
            topPos: 0,

            scroll: 0,
            windowWidth: 0,
            windowHeight: 0
        },

        callbacks: {
            close: null,
            onPostShow: null,
            onReposition: null
        },

        _isCreated: false,
        _isMaskCreated: false,
        _type: 'basic',

        triggerElement: null,

        initialize: function (options) {
            this.constructor.setOptions(options);
            var shopClass = this.parent;

            this.object = {
                    container: null,
                    header: null,
                    body: null,
                    footer: null,

                    mask: null,

                    position: {}
                },

                this.params = {
                    width: 0,
                    height: 0,
                    leftPos: 0,
                    topPos: 0,

                    scroll: 0,
                    windowWidth: 0,
                    windowHeight: 0
                },

                this._isCreated = false;
            this._isMaskCreated = false;
        },

        createModal: function () {
            if (this._isCreated) {
                this.showModal();

                if (this.options.showMask) {
                    this._showMask();
                }

                return false;
            }

            if (this.options.showMask && !this._isMaskCreated) {
                this._createMask();
            }

            const modalLabelId = `modal-label-${uuidv4()}`

            this.object.container = $(`
                <div
                    class="modal modal-not-visible"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="${modalLabelId}"
                />
            `).appendTo(document.body);
            this.object.container.on('keydown', (ev) => {
                if (ev.key === 'Escape') {
                    this.hideModal();
                    this._hideMask();
                    return;
                }

                this.handleTabNavigation(ev, this.object.container[0]);
            });

            this.object.header = $('<div class="modal-header" />').appendTo(this.object.container);
            this.object.body = $('<div class="modal-body" />').appendTo(this.object.container);
            this.object.footer = $('<div class="modal-footer" />').appendTo(this.object.container);

            var h3 = $(`<h3 id="${modalLabelId}" />`).appendTo(this.object.header);
            var closeButton = $(`<div class="modal-close" role="button" tabindex="0" aria-label="${Shop.lang.common.close_window}" />`).appendTo(this.object.header);
            closeButton.on('keydown', (ev) => {
                if (ev.key !== 'Enter' && ev.key !== ' ') return;

                ev.preventDefault();

                this.hideModal();
                this._hideMask();
            });

            closeButton.html('<span class="modal-close-txt">' + Shop.lang.common.close + '</span>').on('click', this, function (e) {
                e.data.hideModal();
                e.data._hideMask();
            });

            this.loadContent();
            this._isCreated = true;

            var width = $(window).width();
            var height = $(window).height();
            var resize = this.parent.debounce(function () {
                if (width !== $(window).width() || (height !== $(window).height())) {
                    this._calculatePosition();
                    this.reposition();

                    width = $(window).width();
                    height = $(window).height();
                }
            }.bind(this), 200);

            $(window).on('resize', resize);
        },

        handleTabNavigation: function(ev, $modalContainerElement) {
            if (ev.key !== 'Tab') return;

            if (ev.shiftKey) {
                this.handleTabBackwardNavigation(ev, $modalContainerElement)
                return;
            }

            this.handleTabForwardNavigation(ev, $modalContainerElement);
        },

        handleTabBackwardNavigation: function(ev, $modalContainerElement) {
            const $lastFocusableModalElement = UiDomUtils.getLastFocusableElement($modalContainerElement);
            const $focusableElements = UiDomUtils.getFocusableElements(document.body);

            const isCurrentElementFirstFocusable = $focusableElements[0] === ev.target;

            if (isCurrentElementFirstFocusable) {
                ev.preventDefault();
                $lastFocusableModalElement.focus();
            }
        },

        handleTabForwardNavigation: function(ev, $modalContainerElement) {
            const $firstFocusableElement = UiDomUtils.getFocusableElement($modalContainerElement);
            const $focusableElements = UiDomUtils.getFocusableElements(document.body);

            const isCurrentElementLastFocusable = $focusableElements[$focusableElements.length - 1] === ev.target;

            if (isCurrentElementLastFocusable) {
                ev.preventDefault();
                $firstFocusableElement.focus();
            }
        },

        showModal: function () {
            if (this.params.scroll !== $(window).scrollTop()) {
                this._calculatePosition();
            }

            this.reposition();

            this.object.container.removeClass('modal-hidden');

            setTimeout(function () {
                this.object.container.removeClass('modal-not-visible').addClass('modal-visible');
            }.bind(this), 400);

            if (typeof (this.callbacks.onPostShow) === 'function') {
                this.callbacks.onPostShow.call(e.data, arguments);
            }

            if (!this.triggerElement) {
                this.triggerElement = document.activeElement;
            }

            UiDomUtils.setFocusToFirstFocusableElementInContainer(this.object.container[0]);

            this.addInertToBodyChildrenElements();
        },

        addInertToBodyChildrenElements: function() {
            [...document.body.children].forEach((child) => {
                if (![...child.classList].some((className) => className.includes('modal'))) {
                    child.setAttribute('inert', '');
                }
            });
        },

        hideModal: function () {
            this.object.container.removeClass('modal-visible').addClass('modal-not-visible');
            setTimeout(function () {
                this.object.container.addClass('modal-hidden');
            }.bind(this), 400);

            if (typeof (this.callbacks.close) === 'function') {
                this.callbacks.close.call(this);
            }

            this.removeInertFromBodyChildrenElements();

            this.triggerElement?.focus();
        },

        removeInertFromBodyChildrenElements: function() {
            [...document.body.children].forEach((child) => {
                child.removeAttribute('inert');
            });
        },

        destroyModal: function () {
            this.object.mask.remove();
            this.object.container.remove();
            this._isCreated = false;

            this.removeInertFromBodyChildrenElements();

            this.triggerElement?.focus();
        },

        loadContent: function () {
            if (this.options.header) {
                this.object.header.find('h3').html(this.options.header);
            }

            this.object.body.html(this.options.content);

            this.object.body.css({
                maxWidth: this.options.contentMaxWidth ? this.options.contentMaxWidth : 'auto',
                maxHeight: this.options.contentMaxHeight ? this.options.contentMaxHeight : 'auto'
            });

            if (this.options.footer) {
                this.object.footer.html(this.options.footer);
            } else {
                this.object.footer.remove();
            }

            this._calculatePosition();
            this.showModal();

            setTimeout(this.showModal.bind(this), (this._isMaskCreated ? 200 : 0));
        },

        _calculatePosition: function () {
            var mPos = {};
            var position = this.options.position.toLowerCase();
            var isMobile;
            var isFullView;
            var widthScale;
            var offsetTop;

            this.object.container.css('width', 'auto');
            this.params.width = this.object.container.outerWidth();
            this.params.height = this.object.container.outerHeight();
            this.params.leftPos = this.object.container.offset().left;
            this.params.topPos = this.object.container.offset().top;

            this.params.scroll = $(window).scrollTop();
            this.params.windowWidth = $(window).width();
            this.params.windowHeight = $(window).height();

            isMobile = this.params.windowWidth < this.options.mobileBreakPoint ? true : false;
            isFullView = isMobile && this._type !== 'alert';

            if (this.params.windowWidth < 768) {
                widthScale = isFullView ? 100 : 90;

                this.params.width = (this.params.windowWidth * widthScale) / 100;
                this.object.container.width(this.params.width);

                if (isFullView) {
                    this.params.height = this.params.height < this.params.windowHeight ? this.params.windowHeight : this.params.height;
                    this.object.container.height(this.params.height);
                }
            }

            if (this.options.positionType === 'fixed') {
                this.object.container.css('position', 'fixed');

                if (this.params.height > this.params.windowHeight) {
                    this.options.positionType = 'absolute';
                    this._calculatePosition();
                    return false;
                }

                if (position.indexOf('center') !== -1) {
                    mPos.top = (this.params.windowHeight / 2) - (this.params.height / 2);
                    mPos.left = (this.params.windowWidth / 2) - (this.params.width / 2);
                }
            } else {
                offsetTop = isFullView ? 0 : this.options.offset;

                this.object.container.css('position', 'absolute');

                if (this.params.height < this.params.windowHeight) {
                    this.options.positionType = 'fixed';
                    this._calculatePosition();
                    return false;
                }

                if (position.indexOf('center') !== -1) {
                    mPos.top = Math.max(this.params.scroll + offsetTop, 0);
                    mPos.left = (this.params.windowWidth / 2) - (this.params.width / 2);
                }

                if (position.indexOf('top') !== -1) {
                    mPos.top = this.params.scroll + offsetTop;
                }
            }

            this.object.position = mPos;
            return mPos;
        },

        reposition: function () {
            if (typeof this.callbacks.onReposition === 'function') {
                this.callbacks.onReposition(this.object.position);
            }

            this.object.container.css(this.object.position);
        },

        _createMask: function () {
            this.object.mask = $('<div class="mask" />').hide();
            this.object.mask.appendTo(document.body);
            this._showMask();
        },

        _showMask: function () {
            this.object.mask.show();
        },

        _hideMask: function () {
            this.object.mask.hide();
        },

        alert: function (alert, title) {
            this._type = 'alert';

            if (title) {
                this.options.header = title;
            } else {
                this.options.header = Shop.lang.common.alert;
            }

            this.options.content = alert;
            this.options.footer = $('<a />', {
                'class': 'btn btn-red',
                role: 'button',
                tabindex: '0',
                'text': 'OK'
            }).on('click', this, function (e) {
                e.data.hideModal();
                e.data._hideMask();
            }).on('keydown', (ev) => {
                if (ev.key !== 'Enter' && ev.key !== ' ') return;

                ev.preventDefault();

                this.hideModal();
                this._hideMask();
            });

            this.createModal();
            this.object.container.addClass('modal-alert');
            this.object.header.find('.modal-close').remove();
        }
    });
})();